// all dimensions in pixels
export const NAVBAR = {
  SIDE_WIDTH: 80,
  FULL_WIDTH: 300,
  SIDE_ICON_SIZE: 28, // used as width and height
};

export const ELECTRON_HEAD = {
  HEIGHT: 0,
};

export const PLAYER_CONTROLS = {
  HEIGHT: 55,
};

export const PLAYER = {
  // CONTROLS
};
